import { useMemo } from 'react';
import {
  GetGroupReportTopicsResponse,
  GetChatsPageResponse,
} from '@mavatar/melingo-voice-and-avatar-sdk/dist/Tutor/EllReport';
import classNames from './TutorReportModal.module.scss';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import rightArrow from '@/assets/svg/right-arrow-full.svg';

interface TutorUserReportProps {
  startHead: any;
  header: any;
  userTopics: GetGroupReportTopicsResponse[];
  setSelectedTopic: (topic: GetChatsPageResponse) => void;
}

const TutorUserReport = ({
  startHead,
  header,
  userTopics,
  setSelectedTopic,
}: TutorUserReportProps) => {
  const { t } = useTranslation();

  const TopicsList = useMemo(() => {
    if (!userTopics?.length) {
      return null;
    }

    return (
      <div className={classNames.topicsContainer}>
        {userTopics.map((topic, index) => {
          return (
            <div className={classNames.topicWrapper} key={`topic--${index}`}>
              <div className={classNames.topicInfo}>
                <div className={classNames.topicDetails}>
                  <div className={classNames.topicTextContainer}>
                    <div className={classNames.topicName}>{`💬 ${topic.topic}`}</div>
                    <div className={classNames.conversationCount}>
                      {t(
                        topic.conversations?.length === 1
                          ? 'my_tutor_page.report.conversation1'
                          : 'my_tutor_page.report.conversationsN',
                        {
                          numberOfConversations: topic.conversations?.length || 0,
                        }
                      )}
                    </div>
                  </div>
                </div>
                <SVG
                  className={classNames.nextIcon}
                  src={rightArrow}
                  onClick={() => {
                    setSelectedTopic({
                      numberOfConversations: topic.conversations.length,
                      topic: topic.topic,
                      CEFRLevel: topic.CEFRLevel,
                      levelId: topic.levelId,
                      unitId: topic.unitId,
                      topicId: topic.topicId,
                      activityId: topic.activityId,
                      createdDate: new Date(topic.lastCreatedDate),
                      numberOfMistakes: 0,
                      maxRank: 0,
                      minRank: 0,
                    });
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }, [t, userTopics, setSelectedTopic]);

  return (
    <div className={classNames.report}>
      <div className={classNames.head}>
        {startHead}
        {header}
      </div>
      <div className={classNames.body}>{TopicsList}</div>
    </div>
  );
};

export default TutorUserReport;
